const preventDefault = (e) => {
  e = e || window.event
  if (e.preventDefault) e.preventDefault()
  e.returnValue = false
}

const disableScroll = function () {
  if (window.addEventListener) window.addEventListener('DOMMouseScroll', preventDefault, false) // older FF
  window.onwheel = preventDefault // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault // older browsers, IE
  window.ontouchmove = preventDefault // mobile
}

const enableScroll = function () {
  if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false)
  window.onmousewheel = document.onmousewheel = null
  window.onwheel = null
  window.ontouchmove = null
}

export { disableScroll, enableScroll }



// WEBPACK FOOTER //
// ./src/plugins/toggleScroll.js